module.exports = __webpack_public_path__ + "static/media/share.c80784e2.jpg";